export const APP_NAME = process.env.REACT_APP_NAME
export const APP_VERSION = process.env.REACT_APP_VERSION
export const APP_DESCRIPTION = process.env.REACT_APP_DESCRIPTION
export const APP_SHA = process.env.REACT_APP_SHA || Date.now()

export const LU_API_ENDPOINT = process.env.REACT_APP_LU_API_ENDPOINT
//TODO real bearer
export const LU_AUTH_HEADER = process.env.REACT_APP_LU_AUTH_HEADER
export const LU_AUTH_TOKEN = process.env.REACT_APP_LU_AUTH_BEARER

export const WEBSITE_NAME = process.env.REACT_APP_WEBSITE_NAME

export const MODES = {
  CODE: 'code',
  DETAIL: 'detail'
}
export const ENTRIES = {
  GET_COMMIT_ID: 'GetCommitId',
  GET_MODEL_INFO: 'GetModelInfo',
  GET_APOLLO_CONFIG: 'GetApolloConfig'
}
export const APPS = {
  NLU: 'nlu',
  NLC: 'nlc',
  INSIGHT: 'insight',
  ATTENTION: 'attention',
  EMBEDDING_SEARCH_SERVER: "embedding-search-server", 
  EMBEDDING_SERVER: "embedding-server",
  LU_MANAGERL: "lu-manager",
  DOMAIN_DECTECTOR: "domain-detector",
  CLASSIFIER_SERVER: "classifier-server",
}
export const ENVS = {
  DEV: 'dev',
  STG: 'stg',
  PRD: 'prd',
  PRE: 'pre',
  NTA: 'nta',
  JD: 'jd'
}
export const ENTRIES_URL = {
  ALL: 'all',
  GET_COMMIT_ID: 'commit',
  GET_MODEL_INFO: 'model',
  GET_APOLLO_CONFIG: 'config'
}

/**
 * keep this for auto gen env1_env2 envsUrl
 */
// const envKeys = Object.keys(ENVS)

// const devStgPrdKeys = envKeys.slice(0,3)
// const prdPreNtaKeys = envKeys.slice(3,6)
// const genUrl = (envKeys) => {
//   const envUrls = {}
//   envKeys.slice(0,3).forEach(key=>{
//     envKeys.filter(k=>k!==key).forEach(k=>{
//       envUrls[`${key}_${k}`] = `${ENVS[key]}_${ENVS[k]}`.toLowerCase()
//     })
//   })
//   return envUrls
// }
// const envUrls = {
//   ...genUrl(devStgPrdKeys),
//   ...genUrl(prdPreNtaKeys)
// }

export const ENVS_URL = {
  DEV_STG: "dev_stg",
  STG_PRD: "stg_prd",
  PRE_NTA: "pre_nta",
  PRE_PRD: "pre_prd",
  NTA_PRD: "nta_prd",
  JD_PRD: "jd_prd",
}